<template>
    <div class="home view-style">
        <!-- header组件 -->
        <el-header/>
        <!-- 左侧区域, -->
        <div class="left-area left-area-style">
            <!-- 扫码量折线图 -->
            <div class="scan-code-area">
                <scan-code-chart/>
            </div>
            <!-- 产品分类统计饼图 -->
            <div class="can-code-area">
                <products-categroy/>
            </div>
            <!-- 产品赋码构成柱形图 -->
            <products-constitute/>
        </div>
        <!-- 右侧区域 -->
        <div class="right-area right-area-style">
            <!-- todolist区域 -->
            <div class="todo-list-area">
                <todo-list :todoTitle="finishList" :newsList="finishListInfo"/>
                <v-news :todoTitle="readyList" :newsList="readyListInfo"/>
            </div>
            <!-- table区域 -->
            <div class="company-info bg-center">
                <company-table/>
            </div>
        </div>
        <!-- button组件 -->
        <div class="button-area">
            <el-button title="实时监控" :icon="icon" route="/video"/>
        </div>
        <!-- 点击新闻要展开的box区域 -->
        <news-info/>
        <!-- mask全屏遮罩层 -->
        <full-mask v-if="$store.state.newsFade"/>
    </div>

</template>

<script>
    //引入header
    import elHeader from "../components/Header";
    //引入扫码量折线图，
    import scanCodeChart from "../components/Home/ScanCodeNum";
    //引入产品分类饼图，
    import productsCategroy from "../components/Home/ProductsCategory";
    //引入产品赋码构成
    import productsConstitute from "../components/Home/ProdCons";
    //引入右侧todolist
    import todoList from "../components/Home/TodoList";
    import news from "../components/Home/newsList.vue";
    //引入公司详情table页面
    import companyTable from "../components/Home/CompanyInfo";
    //引入button组件
    import elButton from "../components/Button";
    //引入新闻信息展示框
    import newsInfo from "../components/Home/NewsInfo";
    //引入全屏遮罩层
    import fullMask from '../components/Home/Mask';
    //引入api
    import {showNewsList} from "../api/home.js";
    //引入vuex
    import {mapState} from "vuex";
    import {pushStream, getMonitorInfo} from "../api/video.js";

    export default {
        name: "home",
        data() {
            return {
                data: [],
                //todolist组件接收的title参数
                readyList: "新闻动态",
                //todolist组件接收的title参数
                finishList: "通告通知",
                //baseURL
                // baseURL: "http://gateway.zym.so/portal/gov/showNoticeList?areaId=610424&noticeType=",
                //首页新闻待办列表
                readyListInfo: null,
                //首页新闻已办列表
                finishListInfo: null,
                //是否显示按钮图标
                icon: "&#xe643;",
            };
        },
        components: {
            elHeader,
            scanCodeChart,
            productsCategroy,
            productsConstitute,
            todoList,
            companyTable,
            elButton,
            newsInfo,
            fullMask,
            "v-news": news
        },
        computed: {
            ...mapState(['regionId']),
            ...mapState(['syEnterpriseList'])
        },
        created() {
            //this.reload();
            this.requestList();
            this.data = [];
            this.getVideoList();
        },
        methods: {
            getVideoList() {
                let data = this.syEnterpriseList;
                if (data) {
                    if (typeof data == 'string') {
                        data = JSON.parse(data)
                    }
                    if (data && data != '') {
                        data.forEach(item => {
                            this.getLists(item.org_id)
                        });
                    }
                }
            },
            getStream(deviceId) {
                let data = {
                    deviceId: deviceId
                };
                pushStream(data)
                    .then(res => {
                        let vue = this;
                        if (res.data.code == 0 && res.data == true) {
                            console.log("推流成功");
                            this.num = 0;
                            window.setTimeout(function () {
                                vue.getStream(deviceId);
                            }, 1500 * 1000);
                        } else {
                            if (this.num < 5) {
                                this.num++;
                                setTimeout(() => {
                                    vue.getStream(deviceId);
                                }, 5000)
                            }

                        }
                    });
            },
            getLists(orgId) {
                getMonitorInfo(orgId)
                    .then(res => {
                        if (res.data.suyuanVideoDataNodes) {
                            res.data.suyuanVideoDataNodes.forEach(o => {
                                this.data.push(o);
                            });
                            this.data.forEach(o => {
                                this.getStream(o.deviceId);
                            });
                        }
                    })
                    .catch(err => {
                    });
            },
            /*
            请求
            */
            getData() {
                //获取新闻列表的请求,
                const getNewsData = () => {
                    return showNewsList({
                        areaId: this.regionId,
                        noticeType: 'xw'
                    });
                };
                //获取通告通知的请求,
                const getNotice = () => {
                    return showNewsList({
                        areaId: this.regionId,
                        noticeType: 'tg',
                        current: 1
                    });
                }
                return [getNewsData, getNotice];
            },
            //实际请求函数,
            requestList() {
                const requestAry = this.getData();
                let promiseList = [];
                requestAry.forEach(item => {
                    promiseList.push(item());
                });
                Promise.all(promiseList)
                    .then(res => {
                        //Promise.all一次性get到所有返回数据,
                        //给新闻列表赋值,并且每次只截取六个,没有分页
                        this.readyListInfo = res[0].data.records;
                        this.finishListInfo = res[1].data.records.slice(0, res[1].data.records.length >= 6 ? 6 : res[1].data.records.length);

                    })
                    .catch(err => {
                        //捕获错误,
                        console.log(err);
                    });
            }
        }
    };
</script>

<style lang='less'>
    //左侧移动进来动画,
    @keyframes leftIn {
        0% {
            left: -40vw;
        }
        5% {
            left: -38vw;
        }
        10% {
            left: -36vw;
        }
        15% {
            left: -34vw;
        }
        20% {
            left: -32vw;
        }
        25% {
            left: -30vw;
        }
        30% {
            left: -28vw;
        }
        35% {
            left: -26vw;
        }
        40% {
            left: -24vw;
        }
        45% {
            left: -22vw;
        }
        50% {
            left: -20vw;
        }
        55% {
            left: -18vw;
        }
        60% {
            left: -16vw;
        }
        65% {
            left: -14vw;
        }
        70% {
            left: -12vw;
        }
        75% {
            left: -10vw;
        }
        80% {
            left: -8vw;
        }
        85% {
            left: -4vw;
        }
        90% {
            left: -2vw;
        }
        95% {
            left: 0px;
        }
        100% {
            left: 20px;
        }
    }

    //右侧移动进来动画
    @keyframes rightIn {
        0% {
            right: -40vw;
        }
        5% {
            right: -38vw;
        }
        10% {
            right: -36vw;
        }
        15% {
            right: -34vw;
        }
        20% {
            right: -32vw;
        }
        25% {
            right: -30vw;
        }
        30% {
            right: -28vw;
        }
        35% {
            right: -26vw;
        }
        40% {
            right: -24vw;
        }
        45% {
            right: -22vw;
        }
        50% {
            right: -20vw;
        }
        55% {
            right: -18vw;
        }
        60% {
            right: -16vw;
        }
        65% {
            right: -14vw;
        }
        70% {
            right: -12vw;
        }
        75% {
            right: -10vw;
        }
        80% {
            right: -8vw;
        }
        85% {
            right: -4vw;
        }
        90% {
            right: -2vw;
        }
        95% {
            right: 0px;
        }
        100% {
            right: 20px;
        }
    }

    .home {
        //左侧区域样式
        .left-area {
            animation: leftIn 0.6s linear;

            .scan-code-area {
                height: 30%;
            }
        }

        //右侧区域样式,
        .right-area {
            animation: rightIn 0.6s linear;
            //右侧区域下的todolist区域
            .todo-list-area {
                pointer-events: all;
                position: absolute;
                right: 0px;
                width: 100%;
                height: 60%;
                max-width: 540px;
            }

            //右侧区域下的公司表格区域
            .company-info {
                pointer-events: all;
                position: absolute;
                padding: 20px 15px 15px 10px;
                box-sizing: border-box;
                width: 100%;
                height: 35%;
                max-width: 900px;
                background-image: url("../assets/images/down-right-div.png");
                bottom: 10px;
                right: 0px;
            }
        }

        //按钮区域
        .button-area {
            pointer-events: all;
        }
    }

    .left-area-style {
        padding-top: 42px;
    }
</style>
